import React, { useState, useEffect } from 'react';
import API_BASE_URL from './config';
import './OnboardingWizard.css';

// Import all step components
import OnboardingStep0 from './OnboardingStep0';
import OnboardingStep1 from './OnboardingStep1';
import OnboardingStep2 from './OnboardingStep2';
import OnboardingStep3 from './OnboardingStep3';
import OnboardingStep4 from './OnboardingStep4';
import OnboardingStep5 from './OnboardingStep5';
import OnboardingStep6 from './OnboardingStep6';

const OnboardingWizard = () => {
    const [currentStep, setCurrentStep] = useState(0);
    const [formData, setFormData] = useState({
        company: {
            display_name: '',
            address: '',
            tagline: '',
            types_of_work: []
        },
        logo_url: null,
        city_ids: [],
        users: []
    });

    // Check if onboarding is already complete and redirect/warn accordingly
    useEffect(() => {
        const checkOnboardingStatus = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/api/onboarding/status`, {
                    credentials: 'include'
                });
                
                if (!response.ok) {
                    console.error('Failed to check onboarding status');
                    return;
                }
                
                const data = await response.json();
                
                if (data.should_redirect && data.redirect_to) {
                    // Redirect admin to settings page
                    alert('Onboarding already completed. Redirecting to Company Settings...');
                    window.location.href = data.redirect_to;
                } else if (data.warning_message) {
                    // Show warning for dev users
                    const proceed = window.confirm(data.warning_message + '\n\nDo you want to proceed?');
                    if (!proceed) {
                        window.location.href = '/';
                    }
                }
            } catch (err) {
                console.error('Error checking onboarding status:', err);
            }
        };
        
        checkOnboardingStatus();
    }, []);

    const steps = [
        { number: 0, title: 'Welcome', component: OnboardingStep0 },
        { number: 1, title: 'Company Info', component: OnboardingStep1 },
        { number: 2, title: 'Branding', component: OnboardingStep2 },
        { number: 3, title: 'Locations', component: OnboardingStep3 },
        { number: 4, title: 'Contacts', component: OnboardingStep4 },
        { number: 5, title: 'Users', component: OnboardingStep5 },
        { number: 6, title: 'Review', component: OnboardingStep6 }
    ];

    const handleNext = () => {
        if (currentStep < steps.length - 1) {
            setCurrentStep(currentStep + 1);
        }
    };

    const handleBack = () => {
        if (currentStep > 0) {
            setCurrentStep(currentStep - 1);
        }
    };

    const updateFormData = (stepData) => {
        setFormData({ ...formData, ...stepData });
    };

    const CurrentStepComponent = steps[currentStep].component;

    return (
        <div className="onboarding-wizard">
            <div className="wizard-header">
                <h1>RFQ Tracker Setup</h1>
                <div className="progress-indicator">
                    {steps.map((step) => (
                        <div
                            key={step.number}
                            className={`progress-step ${
                                step.number === currentStep
                                    ? 'active'
                                    : step.number < currentStep
                                    ? 'completed'
                                    : ''
                            }`}
                        >
                            <div className="step-number">{step.number + 1}</div>
                            <div className="step-title">{step.title}</div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="wizard-content">
                <CurrentStepComponent
                    formData={formData}
                    updateFormData={updateFormData}
                    onNext={handleNext}
                    onBack={handleBack}
                    isFirst={currentStep === 0}
                    isLast={currentStep === steps.length - 1}
                />
            </div>
        </div>
    );
};

export default OnboardingWizard;

